import type { BookChapter } from '@/components/books/book';

export function splitTocChapters(chapters: BookChapter[]): {
    aboutChapter: BookChapter | null;
    contentChapters: BookChapter[];
} {
    const aboutChapter = chapters.find(chapter => chapter.number === 0) ?? null;
    const contentChapters = chapters.filter(chapter => chapter.number !== 0);
    return { aboutChapter, contentChapters };
}

export function selectablePlacementChapters(chapters: BookChapter[]): BookChapter[] {
    return chapters.filter(chapter => chapter.number !== 0);
}

export function chapterDropOverIndex(chapters: BookChapter[], contentListOverIndex: number): number {
    const hasAbout = chapters.some(chapter => chapter.number === 0);
    return hasAbout ? contentListOverIndex + 1 : contentListOverIndex;
}
